import { render, staticRenderFns } from "./AssinaturaMobile.vue?vue&type=template&id=2548c94c&scoped=true"
import script from "./AssinaturaMobile.vue?vue&type=script&lang=ts"
export * from "./AssinaturaMobile.vue?vue&type=script&lang=ts"
import style0 from "./AssinaturaMobile.vue?vue&type=style&index=0&id=2548c94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548c94c",
  null
  
)

export default component.exports